import { getAllSubmissionEntries, SubmissionEntry } from 'actions/challenge';
import SubmissionsList from 'components/SubmissionsList';
import LeaderboardContext from 'contexts/leaderboard';
import UserContext from 'contexts/user';
import DefaultLayout from 'layouts/default';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import './index.css';
import { MUIDataTableState, MUISortOptions } from 'mui-datatables';
type ChallengeAllSubmissionsPageProps = {};
const ChallengeAllSubmissionsPage = ({}: ChallengeAllSubmissionsPageProps) => {
  const { leaderboards, getChallenge } = useContext(LeaderboardContext);
  const [submissionData, setSubmissionData] = useState<{
    submissions: SubmissionEntry[];
    total: number;
  }>({ submissions: [], total: 0 });
  const params = useParams<{ id: string }>();
  const [dataOptions, setDataOptions] = useState<{
    page: number;
    sortOrder: MUISortOptions;
    rowsPerPage: number;
    sortKey: string;
  }>({ page: 0, sortOrder: { name: 'Submission Date', direction: 'desc' }, rowsPerPage: 10, sortKey: "submissionDate" });
  const dataHandler = (tableState: MUIDataTableState, sortKey: string) => {
    setDataOptions({ page: tableState.page, sortOrder: tableState.sortOrder, rowsPerPage: tableState.rowsPerPage, sortKey });
    // console.log({ sortOrder });
  };
  useEffect(() => {
    getChallenge([params.id]);
    getAllSubmissionEntries(params.id, dataOptions.rowsPerPage, dataOptions.page, dataOptions.sortKey, dataOptions.sortOrder.direction).then((data) => {
      setSubmissionData(data);
    });
  }, [dataOptions]);
  return (
    <DefaultLayout>
      <div className="ChallengeAllSubmissionsPage">
        {leaderboards[params.id] && (
          <SubmissionsList
            dataHandler={dataHandler}
            data={submissionData.submissions}
            total={submissionData.total}
            rowsPerPage={dataOptions.rowsPerPage}
            showProgress={false}
            metrics={leaderboards[params.id].metrics}
          />
        )}
      </div>
    </DefaultLayout>
  );
};

export default ChallengeAllSubmissionsPage;
